import { Injector } from '@futrli/shared-services';

const injector = new Injector();

export { injector };
